module.exports = __webpack_public_path__ + "static/img/usBottom2.bec2806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom2.png
// module id = SsJb
// module chunks = 2